<template>
  <button
    class="hamburger"
    :class="{ active: isActive }"
    @click.prevent="handleClick"
  >
    <span>{{ text }}</span>
  </button>
</template>

<script lang="js">
  import {mapState} from "vuex";

  export default  {
    name: 'lms-hamburger',
    props: {
      callback: {
        type: Function,
      },
      text: {
        type: String,
        default: 'Toggle Navigation',
      },
    },
    data() {
      return {
        isActive: false,
      }
    },
    computed: mapState(['searchOpen', 'navOpen', 'drawerOpen']),
    watch: {
      /**
	   * Whenever search gets triggered, reset the hamburger menu
       * @param {boolean} newValue
       */
      searchOpen(newValue) {
        if(newValue) {
          this.reset();
        }
      },
      /**
	   * If the nav is triggered open by something else,
	   * make the hamburger active as well
       * @param {boolean} newValue
       */
      navOpen(newValue) {
		this.isActive = newValue;
	  }
    },
    methods: {
      /**
	   * On click, toggle active state and update $store
       */
      handleClick() {
        this.isActive = !this.isActive;
        this.$store.state.navOpen = this.isActive;
        this.$store.state.drawerOpen = false;
      },
      /**
	   * Reset active state to false
       */
	  reset() {
        this.isActive = false;
	  }
    },
}
</script>
